<script module>
  import "../../../widgets.pcss";
  import {tick} from "svelte";
  import WidgetUtil from "../../utils/WidgetUtil.js";

  // eenmalig bij import - alles in <script module> wordt @ import gedaan en niet @ instantiate
  tick().then(() => {
    WidgetUtil.performWidgetsSharedBootSequence(() => {
      console.log('widget boot klaar');
      // hier kan eventuele custom boot logica van dit type widget
    });
  });

</script>
<script>
  // LET OP!
  // LET OP!
  // LET OP!
  // LET OP!
  // De webshop (App.Shop.svelte) gebruikt SvelteKit voor routing.
  // De widgets zijn voor in de site, niet de reserveerstraat, en hebben geen SvelteKit.
  // Om wel componenten (en dus de look) van de reserveerstraat te kunnen gebruiken
  // delen beide lagen elkaars componenten maar zodra je hier ergens voor een widget iets import
  // dat uiteindelijk ook App.Shop import dan zal je vite build voor de widgets klappen met een rollup error.
  // LET OP!
  // LET OP!
  // LET OP!
  import {onMount} from "svelte";

  onMount(() => {
    console.log("Calendar Widget Mounted");
  });

  let settings = $state({});
  let bHasBeenOpened = $state(false);


  // Externe CSS
  let bIsCSSLoaded = $state(false);

  function loadTheme()
  {
    // return RoutingUtil.appendWebshopStyleSheetToPage();
  }


  let oLastProcessedDate = $state({});

  $effect(() => {

  });

  function handleNextClick()
  {
    //progress_actions.goToNextStep();
  }

</script>

<svelte:boundary onerror={(e) => {console.log('Error in Widget.CalendarHome)', e)}}>
  <div class="widget widget-calendar">
    Hello jagshemash!!
  </div>
</svelte:boundary>

<style>
  .widget-calendar {
    padding: 16px;
    /*background-color: #e80000;*/
    background-color: white;
    border-radius: 8px;
    margin-bottom: 16px;
    min-width: 400px;
  }


</style>
